import { cn } from "@/lib/utils";

const baseEditorClassName =
  "prose prose-stone max-w-none min-h-[320px] px-6 py-5 focus:outline-none";

const paginatedEditorClassName = [
  "prose prose-stone min-h-[500px] w-full border-none",
  "bg-transparent focus:outline-none focus:ring-0",
].join(" ");

const paginatedViewportClassName = [
  "flex-1 max-h-[min(78vh,64rem)] overflow-y-auto p-6",
].join(" ");

export function getStoryEditorClassName(options?: {
  className?: string;
  paginated?: boolean;
}) {
  return cn(
    options?.paginated ? paginatedEditorClassName : baseEditorClassName,
    options?.className,
  );
}

export function getStoryViewportClassName(options?: { className?: string; paginated?: boolean }) {
  return cn(options?.paginated ? paginatedViewportClassName : undefined, options?.className);
}
